import { mixinMethods } from '@/main'
import store from '@/store'
import EventBus from '@/eventBus'
import { initializeSubscription, disconnectSubscription } from '../helper'
import {
    onCreateUserNotificationByUserId,
    onUpdateUserNotificationByUserId
} from '@/store/subscriptions'
import { userNotificationsByUserIdAndIsRead } from '@/store/queries'
import { updateUserNotification } from '@/store/mutations'
import { 
    HERA_MESSENGER_NEW_MESSAGE,
    DAILY_ROSTER_IMPORT_COMPLETE,
    DAILY_PERFORMANCE_DATA_IMPORT_COMPLETE,
    WEEKLY_PERFORMANCE_DATA_IMPORT_COMPLETE,
    TASK_REMINDER,
    VEHICLE_MAINTENANCE_REMINDER,
    COUNSELING_SIGNED_BY_ASSOCIATE,
    HIDDEN,
    EXPORT_READY_FOR_DOWNLOAD
} from '@/utilities/constants/notificationTypes'
import { manageSubscription } from '@/views/NotificationSettings/pushNotification'

"use strict";
let subscriptionUserNotification = null
const MAX_ITEMS = 7;

export const userNotificationSubscribe = function(instance){
    const queries = {
        onCreateUserNotificationByUserId,
        onUpdateUserNotificationByUserId
    }
    if(!store.state.userInfo?.id) return
    const input = {
        userId: store.state.userInfo.id
    }
    initializeSubscription(subscriptionUserNotification, queries, input, "subscriptionStore/handleUserNotification", instance)
}

export const config = function(subscriptions){
    const subscription = {}
    subscriptionUserNotification = subscriptions['userNotification'] = {
        loadList: null,
        subscribe: userNotificationSubscribe,
        unsubscribe: (instance) => disconnectSubscription(subscription, instance),
        callback: userNotificationEventCallback,
        subscription
    }
}


export const userNotificationEventCallback = async function(subscriptionState, { data: userNotification, eventName }){
    const eventNames = {
        'onCreate': async () => {
            // Guard against null or undefined userNotification
            if (!userNotification) {
                console.warn('Received null userNotification in subscription callback')
                return
            }

            //check user permission
            const receiveNotificationInApp = store.state.userInfo.receiveNotificationInApp?.includes(userNotification.notificationType)

            // HIDDEN notifications are internal system signals (e.g. import job completion) that drive UI state and must always be processed regardless of user in-app notification preferences
            if (userNotification.notificationType != HIDDEN && !receiveNotificationInApp) return


            let showToast = true
            if('Notification' in window && Notification.permission === 'granted' && userNotification.notificationType != HIDDEN){
                showToast = false
            }
            processUserNotification(userNotification, showToast)
            
            // Check if user has badge counter enabled for this notification type
            const shouldIncrementBadge = store.state.userInfo.badgeCounterPreferences?.includes(userNotification.notificationType)
            
            if(userNotification.notificationType != HIDDEN && shouldIncrementBadge){
                subscriptionState.regularNotifications.unshift(userNotification)
                if(subscriptionState.regularNotifications.length > MAX_ITEMS){
                    subscriptionState.regularNotifications.pop();
                }
                subscriptionState.regularNotificationCount++
                subscriptionState.regularNotifications.lastRenderKey++
            }
        },

        'onUpdate': () => {
            // Guard against null or undefined userNotification
            if (!userNotification) {
                console.warn('Received null userNotification in onUpdate subscription callback')
                return
            }
            
            if(userNotification.isRead === "true"){
                const regularNotifications = subscriptionState.regularNotifications
                const currentUserNotificationIndex = regularNotifications.findIndex(notif => notif.id === userNotification.id)
                if(currentUserNotificationIndex > -1){
                    subscriptionState.regularNotifications.splice(currentUserNotificationIndex, 1)
                    subscriptionState.regularNotifications.lastRenderKey++
                }
                subscriptionState.regularNotificationCount--
            }
        },

        'onDelete': () => {
           
        }
    }
    await eventNames[eventName]()
}



const processUserNotification = async function (notification, showToast) {
    const notificationPayload = notification.payload?.trim().startsWith('{') ? JSON.parse(notification.payload) : {}
    if(notification.title == 'JOB COMPLETE'){
        importJobComplete(notificationPayload, notification.title, notificationPayload.name)
    }
    else if(notification.title.toLowerCase().includes('import complete')){
        const params = notificationPayload.params
        params.notification = notification
        params.showToast = showToast
        importJobComplete(params, 'IMPORT RESULTS', notificationPayload.name)
    }
    else if(notification.title.includes('Error importing your weekly performance data') || notification.title.includes('Warning')){
        notification.showToast = showToast
        EventBus.$emit('weekly-performance-fails', notification)
    }
    else if(notification.title.includes('Error importing your Amazon Spreadsheet')){
        EventBus.$emit('mark-amazon-import-error', notificationPayload)
    }
    else if(notification.notificationType === EXPORT_READY_FOR_DOWNLOAD){
        const notificationPayload = {
            title: notification.title,
            description: notification.description,
            type: notification.title !== 'Export Failed' ? 'success' : 'error' 
        }
        EventBus.$emit('zip-export-notification', notificationPayload)
    }
}

const importJobComplete = function (payload, type, importName = 'WeeklyDataImport'){
    const events = {
        'JOB COMPLETE':{
            'AmazonImport': 'mark-amazon-import-job-complete',
            'CustomCSVImport': 'mark-custom-csv-job-complete',
            'DailyDataImport': 'mark-daily-job-complete',
            'WeeklyDataImport': 'mark-job-complete'
        },
        'IMPORT RESULTS':{
            'AmazonImport': 'load-amazon-import-results',
            'CustomCSVImport': 'load-custom-csv-import-results',
            'DailyDataImport': 'load-daily-import-results',
            'WeeklyDataImport': 'load-import-results'
        }
    }
    EventBus.$emit(events[type][importName], payload)
}
